export default "__VITE_ASSET__t6S9RXZL__"